import Footer from "./Footer";

export { default as ContactTab } from "./ContactTab";

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js